import { render, staticRenderFns } from "./CurriculumMapUnitList.vue?vue&type=template&id=33790ea7&scoped=true&lang=pug&"
import script from "./CurriculumMapUnitList.vue?vue&type=script&lang=ts&"
export * from "./CurriculumMapUnitList.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumMapUnitList.vue?vue&type=style&index=0&id=33790ea7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33790ea7",
  null
  
)

export default component.exports